import React, { Component, Fragment } from 'react';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';

import styles from './referencePointRow.styles';
import HealthIndicators from '../common/healthIndicators';
import NoDataFound from '../common/noDataFound';


function convertBattery(state){
  let s;
  if(+state === 1){
    s = I18n.t('data.batteryState.good');
  }
  if(+state === 0){
    s = I18n.t('data.batteryState.bad');
  }
  return s;
}

class ReferencePointRow extends Component {
  render() {
    const { status } = this.props;
    if (status) {
      return (
        <Fragment>
          <div className={css(styles.base)}>
            <div className={css(styles.field, styles.light)}>
              <HealthIndicators status={status} />
            </div>
            <div className={css(styles.field, styles.zone)}>
              <span className={css(styles.name)}>{status && status.zone}</span>
            </div>
            <div
              className={css(styles.field, styles.location)}
              title={status && status.name}
            >
              <span className={css(styles.name)}>{status && status.name}</span>
            </div>
            <div
              className={css(styles.field, styles.rp)}
              title={status && status.macAddress}
            >
              <span className={css(styles.name)}>
                {status && status.macAddress}
              </span>
            </div>
            <div className={css(styles.field, styles.lastApMac)}>
              <span className={css(styles.name)}>
                {status && status.accessPoint}
              </span>
            </div>
            <div className={css(styles.field, styles.lastSeen)}>
              <span className={css(styles.name)}>
                {status && status.lastSeenAt}
              </span>
            </div>
            <div className={css(styles.field, styles.lastSeen)}>
              <span className={css(styles.name)}>
                {convertBattery(status.batteryStatus)}
              </span>
            </div>
          </div>
        </Fragment>
      );
    }
    return <NoDataFound />;
  }
}

export default ReferencePointRow;



// WEBPACK FOOTER //
// ./src/components/data/status/referencepoint/referencePointRow.js